/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TagKey } from './tagKey';


export interface Tag { 
    /**
     * The internal identifier that uniquely references a Tag
     */
    id?: number;
    tagKey: TagKey;
    /**
     * The tag's name in plain text for human readability
     */
    displayName?: string;
    /**
     * An optional tag's search score multiplier. Search score multiplier is numeric and can be a decimal
     */
    searchScoreMultiplier?: number;
    /**
     * The tag's description
     */
    description?: string;
    /**
     * The User ID of the user who created this tag
     */
    userId?: string;
    /**
     * The User ID of the user who last updated this tag
     */
    lastUpdatedByUserId?: string;
    /**
     * The timestamp of when it is last updated
     */
    updatedTime?: Date;
    parentTagKey?: TagKey;
    /**
     * A boolean flag that shows whether this tag has further children
     */
    hasChildren?: boolean;
}
